import React from 'react';

import { Box, Center, HStack } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { customTheme } from 'theme';

import { WithResourceIcon } from 'components/DataDisplay';
import { IconTypes, ThirdPartyIcon } from 'components/Icons';

export const renderCVEInsights = row => (
  <HStack spacing={5}>
    <Box>
      <WithResourceIcon
        resourceType={IconTypes.Exploitable}
        iconFilled={false}
        iconStyles={{ w: 5, h: 5 }}
        color={
          !!row?.exploitable
            ? customTheme.colors.critical
            : customTheme.colors.gray['250']
        }
        useCustomColor
        spacing={2}
      >
        {!!row?.exploitable ? 'Known Public Exploit' : 'No Public Exploit'}
      </WithResourceIcon>
    </Box>
    <Box>
      <WithResourceIcon
        resourceType={IconTypes.Patch}
        iconFilled={false}
        iconStyles={{ w: 5, h: 5 }}
        color={
          !!row?.fixed_in_version || !isEmpty(row?.patch_versions)
            ? customTheme.colors.green['300']
            : customTheme.colors.critical
        }
        useCustomColor
        spacing={2}
      >
        {!!row?.fixed_in_version || !isEmpty(row?.patch_versions)
          ? 'Patch Available'
          : 'No Patch Available'}
      </WithResourceIcon>
    </Box>
  </HStack>
);

export const renderCVEInformationButton = onClick => (
  <Box boxSize={6} color="primary" cursor="pointer" onClick={onClick}>
    <Center>
      <ThirdPartyIcon />
    </Center>
  </Box>
);
